// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"2353c1a5","230":"2ba268a4","416":"2c2f2b6f","501":"ab9b0ef4","569":"eb216db7","578":"37d223fe","599":"6b4288e2","621":"3e24aaac","628":"2ea10f60","682":"18079f28","772":"796ecfdf","821":"9b5cd64e","852":"f1c3437d","949":"b9635b8b"}[chunkId] + ".chunk.js";
};